/**
 * Base URL of the sponsorship app (brain-event-sponsorship).
 * Set REACT_APP_SPONSOR_APP_URL in .env to override.
 * All "Devino Sponsor" / "Aplică pentru Sponsorizare" links go to this main page (not directly to the form).
 */
const SPONSOR_APP_URL = process.env.REACT_APP_SPONSOR_APP_URL || 'https://sponsori.brain-event.com';
export const SPONSOR_FORM_URL = SPONSOR_APP_URL.replace(/\/$/, '');

/** Checkout — Early Bird 99€ fără Brain Mapping (quiz + alte CTA-uri). */
export const OFFER_NO_BRAINMAPPING_URL =
  process.env.REACT_APP_OFFER_NO_BRAINMAPPING_URL || 'https://my.brain-event.com/oferta-no-brainmapping';

/** Seat selector — Early Bird 99€ fără Brain Mapping, loc auto-selectat. */
export const OFFER_NO_BRAINMAPPING_SEATS_URL =
  process.env.REACT_APP_OFFER_NO_BRAINMAPPING_SEATS_URL ||
  `${OFFER_NO_BRAINMAPPING_URL.replace(/\/$/, '')}/seats?direct_seat_selector=1&ticket_id=early-bird-99-no-bm`;
